import React from 'react';

type ToggleButtonProps = {
  className?: string;
  active?: boolean;
  onClick: () => void;
};

function ToggleButton({
  className,
  active = false,
  onClick,
  ...props
}: ToggleButtonProps) {
  return (
    <button
      type="button"
      className={`w-14 h-8 rounded-full bg-skyblue p-1 focus:outline-none transition-float ${
        className || ''
      } ${active ? 'bg-dodger-blue' : ''}`}
      onClick={onClick}
      {...props}
    >
      <div
        className={`bg-white w-6 h-6 rounded-full ${
          active ? 'float-right' : ''
        }`}
      ></div>
    </button>
  );
}

export default ToggleButton;
